import { useUIContext } from 'lib/context/UIContext/UIContext';
import { ia, iaRa } from 'lib/helpers/utility';

import { groupStatusContent } from '../lib/constants';
import { mergeAllRows } from '../lib/helpers';

import TableBodyHeader from './TableBodyHeader';
import TableContent from './TableContent';
import TableFooter from './TableFooter';
import TableHeaderRow from './TableHeaderRow';

const TableConfirmedContent = ({
  invoices,
  visibleCols,
  statusGroup,
  openModal,
  invoice: originalInvoice,
  CustomRowHeader,
  checkin,
  preview,
  variant,
  footer
}) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  return (
    <tr>
      <td colSpan={visibleCols.length} className="p-0">
        <div className="w-full overflow-x-auto rounded-xl border border-solid border-neutral-200 bg-white print:overflow-visible">
          <table className="h-fit w-full max-w-full border-collapse">
            {!isMobile && (
              <colgroup>
                {visibleCols.map((col, idx) => (
                  <col
                    key={idx}
                    style={{
                      minWidth: col.minWidth || 80,
                      width: col.width || 'auto'
                    }}
                  />
                ))}
              </colgroup>
            )}
            <tbody>
              <tr>
                <th colSpan={visibleCols.length} className="p-0">
                  <TableBodyHeader
                    columnDefs={visibleCols}
                    value={groupStatusContent[statusGroup.statusName]?.value}
                    description={groupStatusContent[statusGroup.statusName]?.description}
                    variant={variant}
                    type="alternative"
                    className="border-0 border-b border-solid border-b-neutral-200 "
                  />
                </th>
              </tr>
              {!isMobile && (
                <TableHeaderRow columnDefs={visibleCols} preview={preview} variant={variant} />
              )}
              {iaRa(invoices).map(([invoiceId, invoice], idx) => (
                <TableContent
                  key={invoiceId}
                  invoiceId={invoiceId}
                  dateofservice={invoice.dateofservice}
                  visibleCols={visibleCols}
                  rows={invoice.rows}
                  idx={idx}
                  openModal={openModal}
                  invoice={originalInvoice}
                  CustomRowHeader={CustomRowHeader}
                  checkin={checkin}
                  variant={variant}
                  preview={preview}
                  footer={footer}
                />
              ))}
            </tbody>
            {ia(invoices) && footer && !isMobile && (
              <tfoot>
                <TableFooter
                  columnDefs={visibleCols}
                  rowData={mergeAllRows(iaRa(invoices))}
                  variant={variant}
                />
              </tfoot>
            )}
          </table>
        </div>
      </td>
    </tr>
  );
};

export default TableConfirmedContent;
